interface LanguageText {
    product_name: string;
    tab_product: string;
    tab_bundles: string;
    tab_support: string;
    tab_specs: string;
    tab_media: string;
    btn_buy: string;
}

type SupportedLocale = 'us' | 'ca';

type LangTextType = Record<SupportedLocale, LanguageText>;

export const LangText: LangTextType = {
    us: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    ca: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
};
